import {ITooltipOptions} from "./tooltip.service.interface";

export const tooltipDefaultOptions: Partial<ITooltipOptions> = {
    showOverlay: true,
    showCloseButton: false,
    closeOnClickOutside: true,
}